import React, { useState, useEffect } from 'react';
import styles from './style/EditModal.module.css';
import DOMPurify from 'dompurify'; // 💡 DOMPurify 라이브러리 추가
import { useTranslation } from "react-i18next"; // 👈 추가

export default function EditNicknameModal({ currentNickname, onClose, onSave }) {
  const { t } = useTranslation(); // 👈 추가
  const [newNickname, setNewNickname] = useState(currentNickname);
  const [error, setError] = useState('');

  useEffect(() => {
    setNewNickname(currentNickname);
  }, [currentNickname]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // 💡 입력값 정제 및 유효성 검사
    const sanitizedNickname = DOMPurify.sanitize(newNickname.trim(), { USE_PROFILES: { html: false } });

    if (!sanitizedNickname) {
      // 💡 i18n 키로 대체
      setError(t('mypage.modal.nickname.error.required')); 
      return;
    }
    
    // 💡 정제된 값을 상위 컴포넌트로 전달
    setError('');
    onSave(sanitizedNickname);
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        {/* 💡 i18n 키로 대체 */}
        <h3>{t('mypage.modal.nickname.title')}</h3>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            {/* 💡 i18n 키로 대체 */}
            <label htmlFor="nickname">{t('mypage.modal.nickname.label')}</label> 
            <input
              type="text"
              id="nickname"
              value={newNickname}
              onChange={(e) => setNewNickname(e.target.value)}
              className={styles.inputField}
              maxLength={10} // Example: limit nickname length
            />
            {error && <p className={styles.errorMessage}>{error}</p>}
          </div>
          <div className={styles.buttonGroup}>
            {/* 💡 i18n 키로 대체 */}
            <button type="submit" className={styles.saveBtn}>{t('mypage.modal.button.save')}</button>
            <button type="button" onClick={onClose} className={styles.cancelBtn}>{t('mypage.modal.button.cancel')}</button>
          </div>
        </form>
      </div>
    </div>
  );
}